import React, { useState, useEffect, useLayoutEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import leftarr from "../../styles/images/leftpagination.svg";
import rightarr from "../../styles/images/rightpagination.svg";
import { Form, Dropdown } from "react-bootstrap";
import styles from "./teams.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { API_ROUTE_CONTROLLER } from "../../app/base/routes";
import {
  ApiServices,
  worktualTeamsSync,
} from "../../app/base/service/apiService";
import axios from "axios";
import { setGraphToken, setMsDomain, setTeamsToken } from "../../store/profile";
import { useNavigate } from "react-router-dom";
import Loaders from "../../desktop/loader";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import _ from 'lodash';
import ToastSuccess from "../../desktop/toastSuccess";
import ToastError from "../../desktop/toastError";

const Users = () => {
  const { SearchBar, ClearSearchButton } = Search;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  
  const _login = useSelector((state: any) => state.login.login);
  const sbc_fqdn = _login?.domain_name?.replace('callth.','');
  const [userData, setUserData] = useState([]);
  const loggedMail = useSelector((state: any) => state.login.loginCred);
  const tokenValues = useSelector((state: any) => state.profile);
  const [user_list, setUser_list] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [getSyncedUser, setSyncedUser] = useState<any>([]);
  const [getMatchData, setMatchData] = useState<any>([]);

  const [getselectedTeamsUser, setSelectedTeamsUser] = useState<any>([]);
  const [isLoader, setIsLoder] = useState<boolean>(false);
  const [getToastMessage, setToastMessage] = useState('');
  const [getToastErrorMessage, setToastErrorMessage] = useState('');

let tempSynceduser:any = [];

  const getSyncedUserList = async () => {
    let _url = API_ROUTE_CONTROLLER.teamsuserlistapi;
    let _body = {
      p_company_id: _login.company_id,
      p_email: '',
    };
   await ApiServices.post(_body, _url).then((value: any) => {
      setSyncedUser(value.data.result);
      tempSynceduser= value.data.result;
    });
  };

  useLayoutEffect(() => {
    getSyncedUserList();
    setIsLoder(true);
    getAdminDomainName();
    
  }, []);

  const statusChangeFunc = (e: any, index: any, data: any) => {

    if(getselectedTeamsUser.length === 10) {
    console.log("more than 10 elements ");
    setToastMessage('sync user must be 10 users only');
    setTimeout(()=>{
    setToastMessage('');
    }, 3000);
    return true;
    }
    let statusChagnesArray  =  [...getMatchData];
    statusChagnesArray[index].status = e.target.checked ? 1 : 0;
    setMatchData(statusChagnesArray);

    let updatedData: any = {
        'did_number': `+${data.did_number}`,
        'ext': data.ext_number,
        'email': data.mail,
        'status': e.target.checked ? 1 : 0
    };

    console.log("Updated data: ", updatedData);

    setSelectedTeamsUser((prevState: any) => {
        // Create a copy of the previous state
        let newSelectedTeamsUser = [...prevState];
        console.log("newSelectedTeamsUser--------",newSelectedTeamsUser)
        // Check if the user already exists in the list
        let alreadyGetselectedTeamsUserIndex = newSelectedTeamsUser.findIndex(
            (elem: any) => elem.email === data.email
        );
   
        console.log("getSyncedUser-------",getSyncedUser)
       
          if (alreadyGetselectedTeamsUserIndex !== -1) {
            // User exists, update the existing entry
            // newSelectedTeamsUser[alreadyGetselectedTeamsUserIndex] = updatedData;
            console.log("alreadyGetselectedTeamsUserIndex--------",alreadyGetselectedTeamsUserIndex)
        
            console.log("newSelectedTeamsUser--------------",newSelectedTeamsUser)
              newSelectedTeamsUser?.splice(alreadyGetselectedTeamsUserIndex,1)
              

        } else {
            // User doesn't exist, add a new entry
            newSelectedTeamsUser.push(updatedData);
        }
        
        console.log("Before update: ", prevState);
        console.log("After update: ", newSelectedTeamsUser);

        // Return the updated state
        return newSelectedTeamsUser;
    });
};

console.log("getSelected---------------",getselectedTeamsUser)


  // const statusChangeFunc = (e: any, index: any, data:any) => {
    
  //   if(getselectedTeamsUser.length === 10) {
  //     console.log("more than 10 elements ");
  //     setToastMessage('sync user must be 10 users only');
  //     setTimeout(()=>{
  //       setToastMessage('');
  //     }, 3000);
  //     return true;
  //   }
  //   let statusChagnesArray  =  [...getMatchData];
  //   statusChagnesArray[index].status = e.target.checked ? 1 : 0;
  //   setMatchData(statusChagnesArray);
    
    
  //   let prevData:any =[];
    
  //   let alreadyExitsIndex:any = getSyncedUser.findIndex((elem:any)=>elem.email.toLowerCase() === data.email.toLowerCase());    
  //   let alreadyGetselectedTeamsUserIndex = getselectedTeamsUser.findIndex((elem:any)=>elem.email === data.email );

  //   if(e.target.checked) {

  //     let usersData:any = {
  //       'did_number' : `+${data.did_number}`,
  //       'ext' : data.ext_number,
  //       'email' : data.mail,
  //       'status' :  1
  //       }       
          
  //      if(alreadyGetselectedTeamsUserIndex !== -1) {
  //         getselectedTeamsUser[alreadyGetselectedTeamsUserIndex].status = 1;
  //         prevData = getselectedTeamsUser;
  //       }
  //       else {
  //         prevData = [...getselectedTeamsUser, usersData];
  //       }
  //   }
  //     else {
       
  //        if( alreadyExitsIndex !== -1 ) {
  //           let usersData:any  = {
  //           'did_number' : `+${data.did_number}`,
  //           'ext' : data.ext_number,
  //           'email' : data.mail,
  //           'status':  0
  //         }

  //         if(alreadyGetselectedTeamsUserIndex!== -1 ) {
  //           getselectedTeamsUser[alreadyGetselectedTeamsUserIndex].status = 0;
  //           prevData = getselectedTeamsUser;

  //         }
  //         else {
  //           prevData = [...getselectedTeamsUser, usersData];
  //         }         
  //        }
  //        else if(alreadyGetselectedTeamsUserIndex !==  -1) {
  //         getselectedTeamsUser.splice(alreadyGetselectedTeamsUserIndex);
  //         prevData= getselectedTeamsUser;
  //        }
       
  //     }

  //     setSelectedTeamsUser(prevData);
  // };


  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: <img src={leftarr} />,
    nextPageText: <img src={rightarr} />,
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
        value: getMatchData.length,
      },
    ],
  };

  const columns = [
    {
      dataField: "displayName",
      text: "Teams User",
      sort: true,
      formatter: (base: any, row: any) => {
        return (
          <div className={styles.namelogo}>
            <h3>{row.displayName.charAt(0)}</h3>
            <div className={styles.namesection}>
              <div className={styles.nameboard}>
                <p className={styles.clickble}>{row.displayName}</p>
                {/* <p>{row.mail} </p> */}
                <div className={styles.namelist}>
                  <p>{row.mail} </p>
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "directRouting",
      text: "Service Type",
      sort: true,
      formatter: (base: any, row: any) => {
        return (
          <div className={styles.namelist}>
            <h6>Teams Phone Standard</h6>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: "worktual User (Worktual)",
      sort: true,
      formatter: (base: any, row: any) => {
        return (
          <div className={styles.namelogo}>
            <div className={styles.namesection}>
              <div className={styles.nameboard}>
                {/* {row.name && <h3>{ row.name.charAt(0) }</h3>} */}
                <p className={styles.clickble}>{row.name}</p>
                {/* <p>{row.email} </p> */}
                <div className={styles.namelist}>
                  <p>{row.email} </p>
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (base: any, row: any, index: any) => {
        console.log("row.status ----",row.status );
        return (
          <span>
            <Form.Check
              type="switch"
              id="custom-switch-connecting-message"
              name="connecting_message_state_settings"
              className="newgridswitch"
              defaultChecked={row.status ? true : false}
              onChange={(e) => {
                statusChangeFunc(e, index, row);
              }}
            />
          </span>
        );
      },
    },
  ];
  const data = [{}];

  const getAdminDomainName = async () => {
    const url = API_ROUTE_CONTROLLER.domain_Admin;
    const headers = {
      authorization : tokenValues.graphToken
    }
        await axios.get(url,{headers}).then(async(resp) => {

      if(resp.data.statusCode === 200) {
        getUserDomain(resp.data.domain.id);
        dispatch(setMsDomain(resp.data.domain.id));
        
      }else if(resp.data.statusCode === 401 && resp.data.result.message === "Session expired or invalid"){
        let urlRefreshUrl = API_ROUTE_CONTROLLER.refresh_token_graph + "/" + _login?.domain_id;
        let refreshToken = await axios.get(urlRefreshUrl, { headers });

        if (refreshToken.data.statusCode = 200) {
          dispatch(setGraphToken(refreshToken.data.results.token));

          let domainName1 = await axios.get(url, { headers: { Authorization: refreshToken.data.results.token } });
          getUserDomain(domainName1.data.domain.id);
          dispatch(setMsDomain(domainName1.data.domain.id));
        }
      }
    }).catch((err) => {
      console.log("err----------",err)
    })
  }

  const getUserDomain = async (domainName:any) => {
    let loggedWorktualDomain = loggedMail.email.split("@").pop();
    if (domainName.toLowerCase() === loggedWorktualDomain.toLowerCase()) {
      await matchTeamWorktualUser();
    } else {
      console.log("domains are not matched--------");
      setToastMessage('Domain not be same');
      setTimeout(()=>{
        setToastMessage('');
      }, 3000);
    }
  };

  const matchTeamWorktualUser = async () => {
    console.log("match team----");
    let url = API_ROUTE_CONTROLLER.user_list;

    let headers = {
      Authorization: tokenValues.graphToken,
    };

    let _url = API_ROUTE_CONTROLLER.Urmyaccwebuserorderextension;
    let _body = {
      OrderId: _login.order_id,
      Order_Type: "2",
    };

    
    let teamUsers = await axios.get(url, { headers });
  
    setUserData(teamUsers.data.result);


    if (
      teamUsers.data.statusCode === 401 &&
      teamUsers.data.result.message === "Session expired or invalid"
    ) {
      let urlRefreshUrl =
        API_ROUTE_CONTROLLER.refresh_token_graph + "/" + _login?.domain_id;
      let refreshToken = await axios.get(urlRefreshUrl, { headers });
      if ((refreshToken.data.statusCode = 200)) {
        dispatch(setGraphToken(refreshToken.data.results.token));

        teamUsers = await axios.get(url, {
          headers: { Authorization: refreshToken.data.results.token },
        });
      }
    }

    let worktualUser = await ApiServices.post(_body, _url);
   
    let reformedarray: any = [];

    for (let elem of teamUsers.data.result) {
   
      if (elem.mail) {
        let teamsMailSplit = elem.mail.split("@").shift();
   
        for (let value of worktualUser.data.finalresponse) {
     
          value.statusWorktual = value.status;
          delete value.status;
          let worktualMailSplit = value.email.split("@").shift();
       
          if (teamsMailSplit === worktualMailSplit && value.did_number) {
         
            let particularSyncedUser = tempSynceduser.find((data:any)=> data.email === elem.mail );
        
            if(!_.isEmpty(particularSyncedUser)) { elem.status = particularSyncedUser.status }
            else {  elem.status = 0; }
     
            Object.assign(elem, value);

            reformedarray.push(elem);
          }
        }
   
      }
    }
    
    setMatchData(reformedarray);
    setIsLoder(false);
    if(reformedarray.length === 0) {
      setToastErrorMessage("users must have to be same E-mail Id and worktual users must have DID number")
      setTimeout(() => {
        setToastErrorMessage("");
      },3000); 
    }
    
  };

  const TeamsInsertApi = async () => {
   
    let headers = {
      "authorization-graph": tokenValues.graphToken,
      "authorization-teams": tokenValues.teamsToken,
    };

    let payload = {
      users: getselectedTeamsUser,
      domainName : _login.domain_name

    };

    setIsLoder(true);

    // let _url = API_ROUTE_CONTROLLER.insertTeamsDirectRouting;
    // let _body = {
    //   p_company_id: _login.company_id,
    //   p_domain_id: _login.domain_id,
    //   p_teams_list: JSON.stringify(getselectedTeamsUser),
    // };
    // console.log("_body----",_body);
    // ApiServices.post(_body, _url).then(async (value: any) => {
    //   console.log("value---", value);
    //   setIsLoder(false);
    // });

   

     let teamsSyncResp = await worktualTeamsSync(payload,headers);
     
     if(teamsSyncResp.statusCode === 200){
      setIsLoder(false);
      let _url = API_ROUTE_CONTROLLER.insertTeamsDirectRouting;
      let _body = {
        "p_company_id": _login.company_id,
        "p_domain_id": _login.domain_id,
        "p_teams_list": JSON.stringify(getselectedTeamsUser),
        "p_fqdn" : sbc_fqdn
      }
      ApiServices.post(_body, _url).then(async (value: any) => {
      setSelectedTeamsUser([]);
      setToastMessage(teamsSyncResp.message);
      setTimeout(()=>{
        setToastMessage('');
      }, 3000);

      });
     }else if(teamsSyncResp.statusCode === 401 && teamsSyncResp.result.message === "Microsft Graph Session expired or invalid"){
      let urlRefreshUrl = API_ROUTE_CONTROLLER.refresh_token_graph + "/" + _login?.domain_id;

        let refreshToken = await axios.get(urlRefreshUrl, { headers:{'Authorization': tokenValues.graphToken}});
        if (refreshToken.data.statusCode = 200) {
          dispatch(setGraphToken(refreshToken.data.results.token));
          headers['authorization-graph'] = refreshToken.data.results.token;
          
          let teamsSyncResp = await worktualTeamsSync(payload,headers);
          console.log("teamsSyncResp refresh token111-----",teamsSyncResp);
          if(teamsSyncResp.statusCode === 200){
           setIsLoder(false);
           let _url = API_ROUTE_CONTROLLER.insertTeamsDirectRouting;
           let _body = {
             "p_company_id": _login.company_id,
             "p_domain_id": _login.domain_id,
             "p_teams_list": JSON.stringify(getselectedTeamsUser),
             "p_fqdn" : sbc_fqdn
           }

           ApiServices.post(_body, _url).then(async (value: any) => {
           setSelectedTeamsUser([]);
           setToastMessage(teamsSyncResp.message);
           setTimeout(()=>{
             setToastMessage('');
           }, 3000);
           });
          }

        }
     }else if(teamsSyncResp.statusCode === 401 && teamsSyncResp.result.message === "Microsft Teams Session expired or invalid"){
      let urlRefreshUrl = API_ROUTE_CONTROLLER.refresh_token_teams + "/" + _login?.domain_id;
          let refreshToken = await axios.get(urlRefreshUrl, {headers:{'Authorization': tokenValues.teamsToken}});
          if (refreshToken.data.statusCode = 200) {
            dispatch(setTeamsToken(refreshToken.data.results.token));
            headers['authorization-teams'] = refreshToken.data.results.token;

            let teamsSyncResp = await worktualTeamsSync(payload,headers);
            console.log("teamsSyncResp refresh token 2222-----",teamsSyncResp);
            if(teamsSyncResp.statusCode === 200){
             setIsLoder(false);
             let _url = API_ROUTE_CONTROLLER.insertTeamsDirectRouting;
             let _body = {
               "p_company_id": _login.company_id,
               "p_domain_id": _login.domain_id,
               "p_teams_list": JSON.stringify(getselectedTeamsUser),
               "p_fqdn" : sbc_fqdn
             }
             ApiServices.post(_body, _url).then(async (value: any) => {
             setSelectedTeamsUser([]);
             setToastMessage(teamsSyncResp.message);
             setTimeout(()=>{
               setToastMessage('');
             }, 3000);
             });
            }

          }
     }else{
      setIsLoder(false);
      console.log("else------");
      setToastMessage(teamsSyncResp.message);
      setTimeout(()=>{
        setToastMessage('');
      }, 3000);
    
     }
  };

  const changePage = (key: number) => {
    console.log("key0000000", key);
    switch (key) {
      case 1:
        navigate("/directrouting");
        break;

      case 2:
        navigate("/directrouting/adminsetup");
        break;

      case 3:
        navigate("/directrouting/pbx");
        break;

      case 4:
        navigate("/directrouting/teams");
        break;

      case 6:
        navigate("/directrouting/account");
        break;

      default:
        navigate("/directrouting");
        break;
    }
  };

  return (
    <>
      <div className="teamstab">
        <div className="breadcrumbarea">
          <h4>Teams Integration</h4>
          <p>
            Direct Routing allows connecting the Teams Phone calling system
            through Worktual that enabling seamless voice communication
            capabilities.
          </p>
          </div>

          <div className={styles.teamstab}>
      
      <ul>
        <li onClick={()=>{changePage(1)}}>
          <span>1</span>
          <h5>Domain verification</h5>
        </li>
        <li onClick={()=>{changePage(2)}}>
          <span>2</span>
          <h5>Admin Setup</h5>
        </li>
        <li onClick={()=>{changePage(3)}}>
          <span>3</span>
          <h5>Servicespbx</h5>
        </li>
        <li onClick={()=>{changePage(4)}}>
          <span>4</span>
          <h5>Servicesteams</h5>
        </li>
        <li className={styles.activetab}>
          <span>5</span>
          <h5>User</h5>
        </li>
        {/* <li onClick={()=>{changePage(6)}}>
          <span>6</span>
          <h5>Account</h5>
        </li> */}
      </ul>
      </div>
        <div className={styles.userscontain}>
          <ToolkitProvider
            data={getMatchData}
            columns={columns}
            keyField="serviceid"
            search={{ defaultSearch: "" }}
          >
            {(props: any) => (
              <>
                <div className={styles.topheader}>
                  <div className={styles.topheaderleft}>
                    <div className="searchclear">
                      <SearchBar {...props.searchProps} />
                      <ClearSearchButton
                        {...props.searchProps}
                        className="clears"
                      />
                    </div>
                    {/* <p>Advanced Filter <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                  <path d="M6.00007 5.90231C5.39757 5.90231 4.83207 5.66791 4.40677 5.24121L0.553271 1.37691C0.260771 1.08391 0.261771 0.609307 0.554771 0.316407C0.848671 0.024407 1.32377 0.0244068 1.61577 0.318407L5.46877 4.18271C5.75247 4.46591 6.24807 4.46591 6.53077 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59327 5.24121C7.16797 5.66801 6.60217 5.90231 6.00007 5.90231Z" fill="#00B885" />
                </svg>
                </p> */}
                  </div>
                  <div className={styles.topheaderright}>
                    <button className ={(getselectedTeamsUser.length > 0 && getselectedTeamsUser.length < 10) ? '' : 'disabledbtn'} onClick={TeamsInsertApi}>Sync Now</button>
                    {/* <Dropdown className="customdropsync"> */}
                    {/* <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M10 0.460938C4.4771 0.460938 0 4.93804 0 10.4609C0 15.9838 4.4772 20.4609 10 20.4609C15.5228 20.4609 20 15.9836 20 10.4609C20 4.93824 15.5228 0.460938 10 0.460938ZM14.7787 7.67704L10.2518 13.5725C9.8539 14.0911 9.2513 14.4094 8.5985 14.4475C8.555 14.4504 8.5111 14.4514 8.4676 14.4514C7.8607 14.4514 7.2786 14.2073 6.8529 13.7688L5.2782 12.1467C4.9896 11.8498 4.9965 11.3742 5.2938 11.0862C5.5911 10.7982 6.0663 10.8059 6.3543 11.1018L7.929 12.7239C8.0833 12.8821 8.2806 12.9671 8.5115 12.9505C8.7322 12.9378 8.9275 12.8343 9.0623 12.6585L13.5892 6.76304C13.8412 6.43494 14.3138 6.37344 14.6405 6.62534C14.9691 6.87734 15.0311 7.34794 14.7787 7.67704Z"
                        fill="#00B885"
                      />
                    </svg>{" "}
                    Sync Now{" "}
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                      >
                        <path
                          d="M6.00009 6.36324C5.39759 6.36324 4.83209 6.12884 4.40679 5.70214L0.553286 1.83784C0.260786 1.54484 0.261786 1.07024 0.554786 0.777344C0.848686 0.485344 1.32379 0.485344 1.61579 0.779344L5.46879 4.64364C5.75249 4.92684 6.24809 4.92684 6.53079 4.64364L10.3843 0.779344C10.6763 0.485444 11.1514 0.485444 11.4453 0.777344C11.7383 1.07034 11.7392 1.54494 11.4468 1.83784L7.59329 5.70214C7.16799 6.12894 6.60219 6.36324 6.00009 6.36324Z"
                          fill="#00B885"
                        />
                      </svg>
                    </span>
                  </Dropdown.Toggle> */}
                    {/* 
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">
                      Another action
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-3">
                      Something else
                    </Dropdown.Item>
                  </Dropdown.Menu> */}
                    {/* </Dropdown> */}
                  </div>
                </div>
                <div className={styles.usetable}>
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    noDataIndication={isLoader ? "" : "No data found"}
                  />
                </div>
              </>
            )}
          </ToolkitProvider>
        </div>
        <div className={styles.footerbtndouble}>
          <button
            className={styles.backbtn}
            onClick={() => {
              navigate("/directRouting/teams");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
            >
              <path
                d="M5.15277 11.666C4.96137 11.666 4.76947 11.5928 4.62297 11.4472L0.758268 7.59371C0.332468 7.16891 0.0976688 6.60351 0.0971688 6.00091C0.0966688 5.39831 0.331568 4.83291 0.758268 4.40621L4.62347 0.553711C4.91647 0.261711 5.39157 0.261712 5.68397 0.555712C5.97647 0.848712 5.97547 1.32331 5.68197 1.61621L1.81727 5.46871C1.67517 5.61031 1.59707 5.79981 1.59707 6.00091C1.59707 6.20111 1.67517 6.38961 1.81727 6.53121L5.68247 10.3847C5.97547 10.6777 5.97637 11.1523 5.68397 11.4452C5.53747 11.5927 5.34507 11.666 5.15277 11.666Z"
                fill="#575CFF"
              />
            </svg>{" "}
            Back
          </button>
          <div className={styles.btnflexx}>
            <button
              className="cancelbtn"
              onClick={() => navigate("/directrouting/teams")}
            >
              Cancel
            </button>
            <button onClick={() => navigate("/directrouting/account")}>Next</button>
          </div>
        </div>
      </div>
      {isLoader && <Loaders />}
      {getToastMessage && <ToastSuccess msg ={getToastMessage}/>}
      {getToastErrorMessage && <ToastError errorMsg={getToastErrorMessage}/>}
    </>
  );
};

export default Users;
